import * as http from "../index";
const buildInsuranceRequest = (request, { requestForgeryToken }) => {
    const content = {
        drivingDistance: request.drivingDistance,
        socialId: request.personalNumber,
        vehicleId: request.id,
        branchId: request.branchId,
    };
    return http
        .builder()
        .method("post")
        .accept("application/json")
        .requestForgeryToken(requestForgeryToken)
        .content(content)
        .build();
};
const validateResponse = (response) => {
    if (!response || !response.successful || !response.response) {
        throw new Error("The request did not succeed");
    }
    return response.response;
};
export const find = (request, config) => http
    .captureStateContext(http.json(`${config.getApiAddress()}/v3/insurance`, buildInsuranceRequest(request, http.context())))
    .then(validateResponse);
